import { gql } from "@apollo/client";

export const BRAND_FIELDS_PRODUCT_FRAGMENT = gql`
  fragment BrandFieldsProduct on Brand {
    id
    name
    isActive
    cities {
      id
      name
      points(input: $pointsInput) {
        id
      }
    }
    points {
      id
      address
      name
      priority
      isActive
      cityId
      city {
        id
        name
      }
    }
  }
`;

export const BRAND_FIELDS_FRAGMENT = gql`
  fragment BrandFields on Brand {
    id
    accountId
    name
    slug
    isActive
    brandCities {
      brandId
      cityId
      priority
      brand {
        id
        name
        slug
      }
      city {
        id
        name
      }
    }
    cities {
      id
      name
    }
    points {
      id
      address
      name
      priority
      isActive
      city {
        id
        name
      }
    }
  }
`;

export const GET_BRAND = gql`
  ${BRAND_FIELDS_FRAGMENT}
  query Brand($input: BrandInput!) {
    brand(input: $input) {
      ...BrandFields
    }
  }
`;

export const GET_BRAND_PRODUCT = gql`
  ${BRAND_FIELDS_PRODUCT_FRAGMENT}
  query BrandWithProducts(
    $input: BrandInput!
    $pointsInput: PointsForCityInput!
  ) {
    brand(input: $input) {
      ...BrandFieldsProduct
    }
  }
`;

export const GET_BRAND_BY_SLUG = gql`
  ${BRAND_FIELDS_FRAGMENT}
  query BrandBySlug($input: BrandBySlugInput!) {
    brandBySlug(input: $input) {
      ...BrandFields
    }
  }
`;

export const GET_BRANDS = gql`
  ${BRAND_FIELDS_FRAGMENT}
  query Brands($input: BrandsInput!) {
    brands(input: $input) {
      ...BrandFields
    }
  }
`;

export const UPDATE_BRAND = gql`
  ${BRAND_FIELDS_FRAGMENT}
  mutation BrandEdit($input: BrandEditInput!) {
    brandEdit(input: $input) {
      ...BrandFields
    }
  }
`;

export const COUNT_BRANDS = gql`
  query BrandCount($input: BrandCountInput!) {
    brandCount(input: $input)
  }
`;

export const CREATE_ELECTRONIC_MENU = gql`
  ${BRAND_FIELDS_FRAGMENT}
  mutation ElectronicMenuCreate($input: ElectronicMenuCreateInput!) {
    electronicMenuCreate(input: $input) {
      ...BrandFields
    }
  }
`;
